<h1>Document Generation Approvals</h1>
<app-config-approval repository="lambda-ingest-product" lambda="lambda-ingest-product"enableRollback="true"></app-config-approval>

<h1>Document Checks Approvals</h1>
<app-config-approval repository="lambda-ingest-product" lambda="lambda-check-product"enableRollback="true"></app-config-approval>
